// ** Icons Import
import { Home, Circle } from 'react-feather'

const wMenu = (user) => {
  const menu = []

  if (user) {
    if (user === 'admin' || user === 'editor') {
  menu.push({
    id: 'dashboards',
    title: 'Dashboards',
    icon: <Home size={20} />,
    badge: 'light-warning',
    navLink: '/dashboard'
   
  })
    
}
}
return menu
}
export default wMenu
